import { render, staticRenderFns } from "./uni-icons.vue?vue&type=template&id=7395f130&scoped=true"
import script from "./uni-icons.vue?vue&type=script&lang=js"
export * from "./uni-icons.vue?vue&type=script&lang=js"
import style0 from "./uni-icons.vue?vue&type=style&index=0&id=7395f130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7395f130",
  null
  
)

export default component.exports